import { render, staticRenderFns } from "./CloudStorage.vue?vue&type=template&id=72fd4db5&scoped=true&"
import script from "./CloudStorage.vue?vue&type=script&lang=js&"
export * from "./CloudStorage.vue?vue&type=script&lang=js&"
import style0 from "./CloudStorage.vue?vue&type=style&index=0&id=72fd4db5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fd4db5",
  null
  
)

export default component.exports